// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__LmP7H","track":"Switch_track__7hc5m","checked":"Switch_checked__bMsBn","switchBase":"Switch_switchBase__XtaY5","thumb":"Switch_thumb__32Pbt"};